
define('text!libs/strand/src/strand-progress-bar/example.html',[],function () { return '<strand-progress-bar percent-complete="100"></strand-progress-bar>\n<strand-progress-bar fill-color="hotpink" percent-complete="25"></strand-progress-bar>\n<strand-progress-bar indeterminate height="8" width="62" percent-complete="50"></strand-progress-bar>';});

